import Vue from 'vue';

// When the request succeeds
const success = (data, context, status) => {
    context.payment = data.payment;

    if( context.payment.captured ) {
        if(status == 'success'){
            context.message = context.$t('payments.success.captured')
        }else{
            context.message = context.$t('payments.error.captured')
        }
    }else{
        if(status == 'success'){
            context.message = context.$t('payments.success.deposit')
        }else{
            context.message = context.$t('payments.error.deposit')
        }
    }
    context.pageTitle = 'Payment ' + context.payment.amount + ' - '+context.payment.title + ' '+context.payment.description;
    context.userCurrency = data.payment.booking.rental.currency ? data.payment.booking.rental.currency.symbol : data.payment.user.currency.symbol;
    context.loading = false;
};

// When the request fails
const failed = (context, error) => {
    context.loading = false;
    context.showToasterError(error);
};

export default (context, permalink, status) => {
    return Vue.$http.get('/p/'+permalink+'/'+status)
        .then((response) => {
            if (response.status === 200) {
                success(response.data, context, status);
            }
        })
        .catch((error) => {
            failed(context, error);
        });
};



// WEBPACK FOOTER //
// ./src/app/services/payment/getByPermalinkWithStatus.js